import { render, staticRenderFns } from "./Linktree.vue?vue&type=template&id=a8fe1788&scoped=true&"
import script from "./Linktree.vue?vue&type=script&lang=js&"
export * from "./Linktree.vue?vue&type=script&lang=js&"
import style0 from "./Linktree.vue?vue&type=style&index=0&id=a8fe1788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fe1788",
  null
  
)

export default component.exports